
<template>
  <div>
    <Header />
    <v-container>
      <v-row></v-row>
      <v-row>
        <v-col cols="6" xl="6">
          <v-card :loading="loading">
            <v-container>
              <v-card-title>
                Options-Pakete
                <v-spacer />
                <v-btn color="primary" @click="addOptionPacks">Paket hinzufügen</v-btn>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">ID</th>
                          <th class="text-left">Name</th>
                          <th class="text-left">Optionen</th>
                          <th class="text-left">Bearbeiten</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in optionPacks" :key="item.id">
                          <td>{{ item.id }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.optionsCount }}</td>
                          <td><v-btn small @click="editOptionPacks(item.id)">Bearbeiten</v-btn></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="6" xl="6">
          <v-card :loading="loading">
            <v-container>
              <v-card-title>
                Optionen
                <v-spacer />
                <v-btn color="primary" @click="addOptions">Motiv hinzufügen</v-btn>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-card class="mt-1 pa-1" v-for="option in options" :key="option.id">
                    <v-row>
                      <v-col cols="2" v-if="option.type == 'motiv'">
                        <v-img max-height="50" contain :src="option.url"></v-img>
                      </v-col>
                      <v-col cols="7" class="pa-5">
                        <p>{{option.name}}</p>
                        <p>Aufpreis: {{option.price}} €</p>
                        
                      </v-col><v-spacer></v-spacer>
                      <v-col cols="3"><v-btn small @click="editOptions(option.id)">Bearbeiten</v-btn></v-col>
                    </v-row>
                  </v-card>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import OptionService from "@/services/OptionService";
import Header from "@/views/general/header";
import router from "@/plugins/router";

export default {
  name: "dashboard",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    options: [],
    optionPacks: []
  }),
  created() {},
  mounted() {
    this.refresh();
  },
  methods: {
    addOptions() {
      router.push({ name: "OptionsAdd" });
    },
    addOptionPacks() {
      router.push({ name: "OptionPackAdd" });
    },

    editOptions(id) {
      router.push({ name: "OptionsEdit", params: { id: id } });
    },

    editOptionPacks(id) {
      router.push({ name: "OptionsPackEdit", params: { id: id } });
    },

    async refresh() {
      this.loading = true;
      try {
        this.options = (await OptionService.getOptions()).data;
        this.optionPacks = (await OptionService.getOptionPacks()).data;

        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

